import { useIntl } from 'react-intl'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import LuxPlusPaymentMethodPicker from './LuxPlusPaymentMethodPicker'

interface Props {
  item: App.MemberSubscriptionItem
  onBack: () => void
  onFailure?: () => void
  onSuccess?: () => void
  renewalDate?: string
}

function LuxPlusManageAccountModalAddBackupPaymentMethod(props: Props) {
  const intl = useIntl()
  const {
    item,
    onBack,
    onFailure,
    onSuccess,
    renewalDate,
  } = props

  return <>
    <ModalHeader
      title={intl.formatMessage({
        id: 'flRO2IippcTvV0NZEaIm',
        defaultMessage: 'Update payment method',
        description: 'Modal header title for updating LuxPlus subscription payment method',
      })}
      onBackButtonClick={onBack}
    />
    <ModalBody>
      <ModalContent>
        <LuxPlusPaymentMethodPicker
          item={item}
          mode="add-backup"
          renewalDate={renewalDate}
          onFailure={onFailure}
          onSuccess={onSuccess}
        />
      </ModalContent>
    </ModalBody>
  </>
}

export default LuxPlusManageAccountModalAddBackupPaymentMethod
